<script setup>
import { onMounted, ref } from 'vue';
import GenericDateTimeMaskV2 from '../generic/GenericDateTimeMaskV2.vue';
import Service from '@/services/equipment-operation';
import Fieldset from 'primevue/fieldset';
import { useToast } from 'primevue/usetoast';
import { useI18n } from "vue-next-i18n";

const { t } = useI18n();

const toast = useToast();
const props = defineProps({
    idScheduledOperation: String
});

const emit = defineEmits(['sendFiscalNotification', 'cancelSendFiscalNotification']);


const data = ref(null);
const load = () => {
    Service.getInfoilDeviationCheckDataSingleTank({ idScheduledOperation: props.idScheduledOperation }, resp => {
        if (resp.success) {
            data.value = resp.data;
        }else{
            toast.add({detail: message && message != '' ? t(message) :  t('messages.generic_error_message'), life:3000, severity:'error'});

        }
    })
}

onMounted(() => {
    load();
})

</script>

<template>
    <main v-if="data">
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-6">
                <div class="grid field m-1">
                    <div class="col-12">
                        <label>{{ $t('tankOperations.tank') }}</label>
                        <InputText disabled type="text" v-model="data.tankCode" class="w-full p-inputtext-sm m-1" />
                    </div>
                    <Fieldset :legend="$t('InfoilDeviationCheck.manualMeasure')" class="col-12 m-1">

                        <div class="col-12">
                            <label>{{ $t('tankOperations.productLevel') }}</label>
                            <InputText readonly type="text" v-model="data.manualMeasure.productLevel"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.temperature') }}</label>
                            <InputNumber mode="decimal" v-model="data.manualMeasure.temperature" :minFractionDigits="2"
                                :maxFractionDigits="2" :class="{ 'w-full p-inputtext-sm m-1': true }" readonly />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.density15') }}</label>
                            <InputNumber mode="decimal" v-model="data.manualMeasure.density15" :minFractionDigits="4"
                                :maxFractionDigits="4" :class="{ 'w-full p-inputtext-sm m-1': true }" readonly />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.waterLevel') }}</label>
                            <InputText readonly type="text" v-model="data.manualMeasure.waterLevel"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.environmentTemperature') }}</label>
                            <InputNumber mode="decimal" v-model="data.manualMeasure.environmentTemperature"
                                :minFractionDigits="2" :maxFractionDigits="2"
                                :class="{ 'w-full p-inputtext-sm m-1': true }" readonly />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.fiscalStockWeight') }}</label>
                            <InputText readonly type="text" v-model="data.manualMeasure.fiscalStockWeight"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.fiscalStockVolume') }}</label>
                            <InputText readonly type="text" v-model="data.manualMeasure.fiscalStockVolume"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.fiscalMovedWeight') }}</label>
                            <InputText readonly type="text" v-model="data.manualMeasure.fiscalMovedWeight"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.fiscalMovedVolume') }}</label>
                            <InputText readonly type="text" v-model="data.manualMeasure.fiscalMovedVolume"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                    </Fieldset>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
                <div class="grid field m-1">
                    <div class="col-12">
                        <label>{{ $t('tankOperations.operationDate') }}</label>
                        <GenericDateTimeMaskV2 v-model="data.measureDate" readonly class="w-full p-inputtext-sm m-1" />
                    </div>
                    <Fieldset :legend="$t('InfoilDeviationCheck.automaticMeasure')" class="col-12 m-1">
                        <div class="col-12">
                            <label>{{ $t('tankOperations.productLevel') }}</label>
                            <InputText readonly type="text" v-model="data.automaticMeasure.productLevel"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.temperature') }}</label>
                            <InputNumber mode="decimal" v-model="data.automaticMeasure.temperature"
                                :minFractionDigits="2" :maxFractionDigits="2"
                                :class="{ 'w-full p-inputtext-sm m-1': true }" readonly />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.density15') }}</label>
                            <InputNumber mode="decimal" v-model="data.automaticMeasure.density15" :minFractionDigits="4"
                                :maxFractionDigits="4" :class="{ 'w-full p-inputtext-sm m-1': true }" readonly />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.waterLevel') }}</label>
                            <InputText readonly type="text" v-model="data.automaticMeasure.waterLevel"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.environmentTemperature') }}</label>
                            <InputNumber mode="decimal" v-model="data.automaticMeasure.environmentTemperature"
                                :minFractionDigits="2" :maxFractionDigits="2"
                                :class="{ 'w-full p-inputtext-sm m-1': true }" readonly />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.fiscalStockWeight') }}</label>
                            <InputText readonly type="text" v-model="data.automaticMeasure.fiscalStockWeight"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.fiscalStockVolume') }}</label>
                            <InputText readonly type="text" v-model="data.automaticMeasure.fiscalStockVolume"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.fiscalMovedWeight') }}</label>
                            <InputText readonly type="text" v-model="data.automaticMeasure.fiscalMovedWeight"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t('tankOperations.fiscalMovedVolume') }}</label>
                            <InputText readonly type="text" v-model="data.automaticMeasure.fiscalMovedVolume"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                    </Fieldset>
                </div>
            </div>
            <div class="col-12 m-1">
                <Fieldset :legend="$t('InfoilDeviationCheck.deviation')" class="w-full">
                    <div class="grid m-1 field">
                        <div class="col-6 mt-1">
                            <label>{{ $t('InfoilDeviationCheck.movedQtyDelta') }}</label>
                            <InputText readonly type="text" v-model="data.movedQtyDelta"
                                class="w-full p-inputtext-sm m-1" />
                        </div>
                        <div class="col-6 mt-1">
                            <label>{{ $t('InfoilDeviationCheck.movedQtyDeltaPercentage') }}</label>
                            <InputNumber mode="decimal" v-model="data.movedQtyDeltaPercentage" :minFractionDigits="2"
                                :maxFractionDigits="2" :class="{ 'w-full p-inputtext-sm m-1': true }" readonly />
                        </div>
                    </div>
                </Fieldset>
            </div>
            <div class="col-12 m-1">
                <div class="grid m-1 field">
                    <div class="col-6 mt-1">
                        <Checkbox v-model="data.sendFiscalNotification" :binary="true" class=" m-1" />
                        <label class="ml-2"> {{ $t('InfoilDeviationCheck.sendFiscalNotification') }} </label>
                    </div>
                    <div class="col-6 mt-1">
                        <Checkbox v-model="data.sendDeviationToInfoil" :binary="true" class=" m-1" />
                        <label class="ml-2"> {{ $t('InfoilDeviationCheck.sendDeviationToInfoil') }} </label>
                    </div>
                </div>
            </div>
            <Message severity="error" :closable="false" v-if="data.thresholdExceeded" class="col-12 m-1">{{ $t('InfoilDeviationCheck.thresholdExceeded') }}</Message>
        </div>
        <div class="m-1">
            <ResponsiveButton :label="$t('btn.send')" icon="pi pi-send" class="p-button-outlined p-button-sm my-2 mx-1"
                :disabled="!data.sendFiscalNotification" @click="emit('sendFiscalNotification', data)" />
            <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times"
                class="p-button-outlined p-button-sm my-2 mx-1" @click="emit('cancelSendFiscalNotification')" />
        </div>
    </main>
</template>